<div class="loading-overlay" [class.is-centered]="centered">
    <div class="loading-bar"></div>
    <div class="loading-icon" [innerHTML]="iconHtml"></div>
    <span class="loading-label">{{ iconLabel }}</span>
</div>
